import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import Investors from "./InvestorMain";
import InvestorDetails from "./InvestorDetails";

export default class InvestorRouter extends Component {
  render() {
    const { history, location } = this.props;
    return (
      <Switch location={location} history={history}>
        <Route path={`/investors/details/:PAN`} component={InvestorDetails} />
        <Route path={`/investors`} exact component={Investors} />
      </Switch>
    );
  }
}
